import React, { useState } from "react";
import { Button, Typography, Box } from "@mui/material";
// import AttachFileIcon from "@mui/icons-material/UploadFile";
import AttachFileIcon from "@material-ui/icons/AttachFile";
import { useDispatch } from "react-redux";
import { isEmpty } from "lodash";
import { UPLOAD_NMAP_FILES } from "./NetSpaceConstant";

const NmapFileUpload = ({ runName, networkName }) => {
  const dispatch = useDispatch();
  const [error, setError] = useState(null);
  const [fileName, setFileName] = useState("");
  const [uploading, setUploading] = useState(false);

  const handleFileChange = (event) => {
    const file = event.target.files[0];

    if (file) {
      const validTypes = [
        "text/xml",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "text/csv",
      ];

      if (validTypes.includes(file.type) || file.name.endsWith(".csv")) {
        setError(null);
        setFileName(file.name);
        handleUpload(file);
      } else {
        setError("Please select a valid XML, XLSX, or CSV file.");
      }
    }
  };

  const handleUpload = async (selectedFile) => {
    try {
      setUploading(true);

      const runObj = {
        runName,
        networkName,
      };

      const formData = new FormData();
      formData.append("payload", JSON.stringify(runObj));
      formData.append("file", selectedFile);

      dispatch({
        type: UPLOAD_NMAP_FILES,
        payload: { formData },
      });
    } catch (error) {
      console.error(error);
    } finally {
      setUploading(false);
    }
  };

  return (
    <Box>
      {/* Hidden input */}
      <input
        id="file-upload"
        type="file"
        accept=".xml, .xlsx, .csv"
        onChange={handleFileChange}
        disabled={isEmpty(runName)}
        style={{ display: "none" }}
      />

      {/* Custom button */}
      <label htmlFor="file-upload">
        <Button
          variant="outlined"
          component="span"
          startIcon={<AttachFileIcon />}
          disabled={isEmpty(runName) || uploading}
          sx={{ textTransform: "none" }}
        >
          Upload File
        </Button>
      </label>

      {/* File name */}
      {fileName && (
        <Typography
          variant="caption"
          sx={{ ml: 1, color: "#2e7d32" }}
        >
          {fileName}
        </Typography>
      )}

      {/* Error */}
      {error && (
        <Typography variant="caption" sx={{ color: "red", display: "block" }}>
          {error}
        </Typography>
      )}
    </Box>
  );
};

export default NmapFileUpload;